export default __webpack_public_path__ + "static/media/steve_director.3a46db81.png";